import PolarisIcon from '@/components/_common/PolarisIcon';
import { Chip, Grid, Tooltip } from '@mui/material';

enum ImportantTagColor {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  error = 'error',
  warning = 'warning',
  info = 'info',
  default = 'default'
}

type ImportantTag = {
  label: string;
  color: ImportantTagColor;
};

interface ImportantTagsProps {
  tags: ImportantTag[];
  iconOnly?: boolean;
}

const ImportantTags = ({ tags = [], iconOnly = false }: ImportantTagsProps) => {
  if (!tags?.length) return;
  const getColorIcon = (color: ImportantTagColor) => {
    switch (color) {
      case 'warning':
        return <PolarisIcon width={iconOnly ? 18 : 14} icon="error" />;
      case 'error':
        return <PolarisIcon width={iconOnly ? 18 : 14} icon="cancel" />;
      case 'info':
        return <PolarisIcon width={iconOnly ? 18 : 14} icon="info" />;
      case 'success':
        return <PolarisIcon width={iconOnly ? 18 : 16} icon="complete_outline" />;
      default:
        return <></>;
    }
  };

  if (iconOnly) {
    return (
      <Grid container alignItems="center" flexWrap="nowrap">
        {tags.map((tag) => (
          <Tooltip title={tag.label} key={tag.label} arrow>
            <Grid container alignItems="center" sx={{ color: `${tag.color}.main` }}>
              {getColorIcon(tag.color)}
            </Grid>
          </Tooltip>
        ))}
      </Grid>
    );
  }
  return tags.map((tag) => (
    <Chip label={tag.label} key={tag.label} icon={<span style={{ width: 15 }}>{getColorIcon(tag.color)}</span>} size="small" color={tag.color} />
  ));
};

export default ImportantTags;
